import { styled } from "@100mslive/roomkit-react";

export const Image = styled("img", {
  width: "100%",
  height: "auto",
  r: "$3",
});
